import React from 'react';
import { TextField, InputAdornment, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { usePlayer } from '../../context/PlayerContext';
import './SearchBar.scss';

const SearchBar = () => {
  const { searchTerm, setSearchTerm } = usePlayer();

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Box className="search-bar">
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search players..."
        value={searchTerm}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
        className="search-input"
      />
    </Box>
  );
};

export default SearchBar;